export const capitalize = str => str.replace(/^\w/, chr => chr.toUpperCase());

export const authToken = () => (dispatch, getState) => {
  const { token } = getState().auth;
  if (!token) throw new Error('No token found');
  return token;
};

// /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const emailRegex = () =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const HFRegex = () => /([H][F]\d+$)/;

function delay(t, v) {
  return new Promise(function(resolve) {
    setTimeout(resolve.bind(null, v), t);
  });
}

// eslint-disable-next-line
Promise.prototype.delay = function(t) {
  return this.then(function(v) {
    return delay(t, v);
  });
};

export const getKey = (object, value) => {
  return Object.keys(object).find(key => object[key] === value);
};

// argument interger
// denomination = [ dollars, cents ]
// specify output denomination..
export const calcGST = (value, gst = 0, denomination = 'dollars') => {
  const gstByPercent = gst / 100;
  const withGST = 1 + gstByPercent;

  if (denomination === 'dollars') return `$${((value / 100) * withGST).toFixed(2)}`;
  else if (denomination === 'cents') return `$${(value * withGST).toFixed(2)}`;
  else return new Error('missing denomination');
};

export const calcOrigin = (value, denomination = 'dollars') => {
  if (denomination === 'dollars') return `$${(value / 100).toFixed(2)}`;
  else if (denomination === 'cents') return `$${value.toFixed(2)}`;
  else return new Error('missing denomination');
};

// parse [] into 2d array of [ [ ...data(n) ], ... ]
export const nestArrays = (array, integer = 8) => {
  const cloned = [...array];
  const newArray = [];
  while (cloned.length > 0) {
    newArray.push(cloned.splice(0, integer));
  }
  return newArray;
};

export const rearrange = array => {
  return [array[0], array[2], array[6], array[7], array[1], array[4]];
};

export const isInArray = (array, element) => {
  return array.indexOf(element) !== -1;
};

export const centsify = int => {
  if (typeof int !== 'number') throw new Error('Invalid price number');
  return int * 100;
};



// WEBPACK FOOTER //
// ./src/store/utility.js